import { useRef, useState, useEffect, useCallback } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";

export const Marquee = () => {
  const { t } = useLanguage();
  const trackRef = useRef(null);
  const [canPrev, setCanPrev] = useState(false);
  const [canNext, setCanNext] = useState(true);

  const updateArrows = useCallback(() => {
    const el = trackRef.current;
    if (!el) return;
    setCanPrev(el.scrollLeft > 4);
    setCanNext(el.scrollLeft + el.clientWidth < el.scrollWidth - 4);
  }, []);

  useEffect(() => {
    updateArrows();
    window.addEventListener("resize", updateArrows);
    return () => window.removeEventListener("resize", updateArrows);
  }, [updateArrows]);

  const scrollBy = (dir) => {
    const el = trackRef.current;
    if (!el) return;
    el.scrollBy({ left: dir * Math.round(el.clientWidth * 0.7), behavior: "smooth" });
  };

  const btnCls = (enabled) =>
    `shrink-0 w-9 h-9 flex items-center justify-center rounded-full border transition-colors duration-300 ${
      enabled
        ? "border-[#1E3A5F]/30 text-[#1E3A5F] hover:bg-[#1E3A5F] hover:text-[#FBF9F5]"
        : "border-[#1E3A5F]/10 text-[#1E3A5F]/25 cursor-default"
    }`;

  return (
    <div className="border-y border-[#E3DED4] bg-[#F4F1EA] py-4" data-testid="editorial-marquee">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 flex items-center gap-4">
        <div
          ref={trackRef}
          onScroll={updateArrows}
          className="flex-1 flex items-center gap-10 whitespace-nowrap overflow-x-auto no-scrollbar"
        >
          {t.marquee.map((item, i) => (
            <span key={i} className="flex items-center gap-10 shrink-0">
              <span className="font-sans text-xs sm:text-sm font-semibold uppercase tracking-[0.2em] text-[#1E3A5F]">{item}</span>
              {i < t.marquee.length - 1 && <span className="w-2 h-2 bg-[#B85D2A] shrink-0" />}
            </span>
          ))}
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <button
            type="button"
            aria-label="Scroll left"
            data-testid="marquee-prev-button"
            onClick={() => scrollBy(-1)}
            disabled={!canPrev}
            className={btnCls(canPrev)}
          >
            <ChevronLeft size={16} strokeWidth={1.75} />
          </button>
          <button
            type="button"
            aria-label="Scroll right"
            data-testid="marquee-next-button"
            onClick={() => scrollBy(1)}
            disabled={!canNext}
            className={btnCls(canNext)}
          >
            <ChevronRight size={16} strokeWidth={1.75} />
          </button>
        </div>
      </div>
    </div>
  );
};
